import dayjs from 'dayjs';

/** IDs otimistas usam Date.now(); IDs do banco ficam bem abaixo disso. */
export const TEMP_MESSAGE_ID_THRESHOLD = 1_000_000_000_000;

const MATCH_WINDOW_MS = 45_000;

export type OptimisticMatchMessage = {
  id: number;
  sentAt: string;
  mediaType: string;
  content?: string | null;
  isSent?: boolean;
  status?: 'sending' | 'sent' | 'error';
};

export function isTempMessageId(id: number): boolean {
  return id > TEMP_MESSAGE_ID_THRESHOLD;
}

export function isOptimisticOutgoing(m: OptimisticMatchMessage): boolean {
  return m.status === 'sending' || (m.status === 'sent' && isTempMessageId(m.id));
}

/** Casa bolha otimista (sending/temp) com mensagem persistida/realtime. */
export function matchesOptimisticSent(
  opt: OptimisticMatchMessage,
  real: OptimisticMatchMessage,
  windowMs = MATCH_WINDOW_MS,
): boolean {
  if (!real.isSent) return false;
  if (!isOptimisticOutgoing(opt)) return false;
  const timeDiff = Math.abs(dayjs(opt.sentAt).valueOf() - dayjs(real.sentAt).valueOf());
  if (timeDiff > windowMs) return false;
  if (opt.mediaType === 'text') return (opt.content ?? '') === (real.content ?? '');
  return opt.mediaType === real.mediaType;
}

/** Versão para poll: a otimista já foi filtrada; só compara conteúdo/tipo/janela. */
export function matchesPendingOptimisticContent(
  opt: OptimisticMatchMessage,
  real: OptimisticMatchMessage,
  windowMs = MATCH_WINDOW_MS,
): boolean {
  if (!real.isSent) return false;
  const timeDiff = Math.abs(dayjs(opt.sentAt).valueOf() - dayjs(real.sentAt).valueOf());
  if (timeDiff > windowMs) return false;
  if (opt.mediaType === 'text') return (opt.content ?? '') === (real.content ?? '');
  return opt.mediaType === real.mediaType;
}

/** Após POST ok: marca temp como enviada (realtime/poll troca pelo id real). */
export function markOptimisticAsSent<T extends OptimisticMatchMessage>(
  messages: T[],
  tempId: number,
): T[] {
  return messages.map(m =>
    m.id === tempId ? { ...m, status: 'sent' as const } : m
  );
}
